/*
* 车辆信息组件
*/

import { useState, useEffect } from 'react';
import {
    ConfigProvider,
    Row,
    Col,
    Modal,
    Button,
    Tag,
    Statistic,
} from 'antd';
import { locale, Html2pdf } from '../../incs/FunHelper.js';
import CNF from '../../incs/Config.js';

import ZHCLOGO from '../../images/yd_logo.jpg';
import XZTLOGO from '../../images/logo_head.png';
import PAGEHEADERRIGHT from '../../images/page-header-right.png';

/**
 * 显示车辆信息
 * @param {*} props 
 * @returns 
 */
const CarInfo = (props) => {
    const [open, setOpen] = useState(props);
    const cancel = () => { setOpen(false); };
    const printer = () => {
        var printContents = document.getElementById('print-info-id').innerHTML;
        var originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
        window.location.reload();
    };
    const download = () => { Html2pdf('print-info-id', props.record.number, ''); };

    useEffect(() => {
        setOpen(props.open);
    }, [props]);
    return (
        <ConfigProvider
            locale={locale}
            theme={{
                token: {
                    colorPrimary: global.THEMECOLOR,
                },
            }}
        >
            <Modal
                width={820}
                style={{ top: 0 }}
                closable={false}
                open={open}
                keyboard={true}
                maskClosable={true}
                onCancel={cancel}
                footer={[
                    <Button key='back' onClick={cancel}>取消</Button>,
                    <Button key='printer' type='primary' onClick={printer}>打印</Button>,
                    <Button key='link' type='primary' onClick={download} style={{ marginRight: 20 }}>下载</Button>,
                ]}
            >
                <div id='print-info-id'>
                    <div className='print-info' style={{ padding: '0 30px' }}>
                        <Row style={{ margin: '10px' }}>
                            <Col span={2}><img src={props.preGroup === 'zhc' ? ZHCLOGO : XZTLOGO} height='45px' alt={props.preGroup === 'zhc' ? '智慧城' : '新致腾'} /></Col>
                            <Col span={22} align='right'><img src={PAGEHEADERRIGHT} height='35px' alt='新致腾' /></Col>
                        </Row>
                        <table width='100%'>
                            <thead align='center'>
                                <tr>
                                    <th colSpan='24'><h2>车辆信息表</h2></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>车牌号码:</td><td colSpan='8' style={{ width: 240 }}>{props.record.license_number}</td>
                                    <td colSpan='4' style={{ width: 120 }}>车辆名称:</td><td colSpan='8' style={{ width: 240 }}>{props.record.name}</td>
                                </tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>车辆型号:</td><td colSpan='8' style={{ width: 240 }}>{props.record.model}</td>
                                    <td colSpan='4' style={{ width: 120 }}>购买时间:</td><td colSpan='8' style={{ width: 240 }}>{props.record.purchase_time}</td>
                                </tr>
                                <tr><td colSpan='4' style={{ width: 120 }}>当前里程:</td><td colSpan='20' style={{ width: 600 }}>
                                    <Tag color={props.colorPrimaryBg}>
                                        <Statistic precision={0} suffix='km' valueStyle={{ fontSize: CNF.fontSize - 2, color: global.THEMECOLOR }} value={props.record.current_mileage} />
                                    </Tag>
                                </td>
                                </tr>
                                <tr><td colSpan='4' style={{ width: 120 }}>驾驶人:</td><td colSpan='20' style={{ width: 600 }}>{props.record.driver_displayname}</td></tr>
                                <tr><td colSpan='4' style={{ width: 120 }}>用途:</td><td colSpan='20' style={{ width: 600 }}>
                                    {props.record.uses && props.record.uses.split('\n').map((item, index) => {
                                        return <p key={index} style={{ margin: 0 }}>{item}</p>;
                                    })}
                                </td></tr>
                                <tr>
                                    <td colSpan='4' style={{ width: 120 }}>创建者:</td><td colSpan='8' style={{ width: 240 }}>{props.record.create_displayname}</td>
                                    <td colSpan='4' style={{ width: 120 }}>创建时间:</td><td colSpan='8' style={{ width: 240 }}>{props.record.create_time}</td>
                                </tr>
                                <tr><td colSpan='4' style={{ width: 120 }}>备注:</td><td colSpan='20' style={{ width: 600 }}>
                                    {props.record.description && props.record.description.split('\n').map((item, index) => {
                                        return <p key={index} style={{ margin: 0 }}>{item}</p>;
                                    })}
                                </td></tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Modal>
        </ConfigProvider>
    );
};

export default CarInfo